import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Login from './pages/Login';
import { ResetPassword, VerifyEmail } from './pages/AuthLink';
import Privacy from './pages/Privacy';
import Unsubscribed from './pages/account/Unsubscribed';
import { AuthProvider, useAuth } from './lib/auth';
import { ThemeProvider } from './lib/theme';
import './styles/theme.css';
import './styles.css';

/** Nothing in the app makes sense without an account, so gate the whole tree. */
function Gate() {
  const { user, loading } = useAuth();
  // Email links work signed in or out, so they are answered before the gate.
  const path = window.location.pathname;
  if (path === '/verify-email') return <VerifyEmail />;
  if (path === '/reset-password') return <ResetPassword />;
  // Readable signed in or out, and linked from the upload box.
  if (path === '/privacy') return <Privacy />;
  // Where every email's unsubscribe link lands: no sign-in needed.
  if (path === '/alerts/unsubscribed') return <Unsubscribed />;
  // Blank rather than a spinner: the session check is a single local request,
  // and a flash of "loading" is worse than a beat of nothing.
  if (loading) return null;
  return user ? <App /> : <Login />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Gate />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
